export const PROJECT = 'project'

export const project = {
  en: {
    translation: {
      project: {
        projectDetails: {
          // Project Management
          projectManagement: 'Project Management',
          status: 'Status',
          type: 'Type',
          woNumber: 'WO Number',
          poNumber: 'PO Number',
          projectName: 'Project Name',
          clientStart: 'Client Start',
          clientDue: 'Client Due',
          woaStart: 'WOA Start',
          woaCompletion: 'WOA Completion',
          clientWalkthrough: 'Client Walkthrough',
          clientSignOff: 'Client Sign Off',
          overrideStatus: 'Override Status',

          // Invoicing & Payment

          invoicingPayment: 'Invoicing & Payment',
          invoicing: 'Invoicing',
          payments: 'Payments',
          originalSowAmount: 'Original SOW Amount',
          finalSowAmount: ' Final SOW Amount',
          invoiceNo: 'Invoice No.',
          uploadInvoice: 'Upload Invoice',
          invoiceBackDate: 'Invoice Back Date',
          paymentTerms: 'Payment Terms',
          woaInvoiceDate: 'Invoice Date',
          woaExpectedPay: 'WOA Expected Pay',
          overpayment: 'Overpayment',
          remainingPayment: 'Remaining Payment',
          payment: 'Payment',
          depreciation: 'Depreciation',
          originalSOW: 'Original SOW',
          invoice: 'Invoice',
          invoiceUpdating: 'Invoice is updating',
          paymentError: `Unable to save payment due to 'Pending' Depreciation/Carrier Fee transaction against Project SOW.`,
          paymentErrorDepreciation: `Unable to save payment due to 'Pending' Depreciation Fee transaction against Project SOW.`,
          paymentErrorCarrier: `Unable to save payment due to 'Pending' Carrier Fee transaction against Project SOW.`,
          paymentSource: 'Payment Source',
          resubmissionDate: 'Resubmission Date',
          notificationDate: 'Notification Date',
          newInvoice: 'New Invoice',
          addNewRow: 'Add New Row',
          deleteRow: 'Delete Row',
          description: 'Description',
          amount: 'Amount',
          subtotal: 'Subtotal',
          balancedue: 'Balance Due',
          paymentReceived: 'Payment Received',
          partialPayment: 'Partial Payment',
          balanceDueError: 'Invoiced Amount cannot be greater than AR.',
          received: 'Received',
          finalSow: 'Final Sow',
          invoiceAmount: 'Invoice Amount',
          invoiced: 'Invoiced',
          date: 'Date',
          sowAmount: 'SOW Amount',
          amountReceived: 'Amount Received',
          remainingAR: 'Remaining AR',
          // Contacts
          contacts: 'Contacts',
          projectCoordinator: 'Project Coordinator',
          phone: 'Phone',
          ext: 'Ext.',
          fieldProjectManager: 'Field Project Manager',
          superName: 'Super Name',
          superPhone: 'Super Phone',
          superEmail: 'Super Email',
          client: 'Client',

          // Location
          location: 'Location',
          address: 'Address',
          city: 'City',
          state: 'State',
          zip: 'Zip',
          market: 'Market',
          gateCode: 'Gate Code',
          lockBoxCode: 'Lock Box Code',
          hoaContactPhone: 'HOA Contact Phone',
          hoaContactEmail: 'HOA Contact Email',

          // Misc
          misc: 'Misc',
          created: 'Created',
          new: 'New',
          active: 'Active',
          punch: 'Punch',
          closed: 'Closed',
          clientPaid: 'Client Paid',
          disputed: 'Disputed',
          collection: 'Collection',
          dueDateVariance: 'Due Date Variance',
          payDateVariance: 'Pay Date Variance',
          payVariance: 'Pay Variance',
          woaPaid: 'WOA Paid',
          reconcileDate: 'Reconciled',
          verifiedDate: 'Verified',

          save: 'Save',
          cancel: 'Cancel',
          seeProjectDetails: 'See Project Details',
        },
      },
    },
  },
  es: {
    translation: {
      project: {
        projectDetails: {
          // Project Management
          projectManagement: 'Gestión de proyectos',
          status: 'Estado',
          type: 'Escribe',
          woNumber: 'Número de orden de trabajo',
          poNumber: 'Numero postal',
          projectName: 'Nombre del proyecto',
          clientStart: 'Fecha de inicio del cliente',
          clientDue: 'Fecha de vencimiento del cliente',
          woaStart: 'Fecha de inicio de WOA',
          woaCompletion: 'WOA Fecha de finalización',
          clientWalkthrough: 'Fecha de recorrido del cliente',
          clientSignOff: 'Fecha de cierre del cliente',
          overrideStatus: 'Anular estado',

          // Invoicing & Payment
          invoicingPayment: 'Facturación y pago',
          originalSowAmount: 'Importe de la SOW original',
          finalSowAmount: 'Importe de la SOW final',
          invoiceNo: 'Número de factura',
          uploadInvoice: 'Cargar factura',
          invoiceBackDate: 'Reembolso de factura',
          paymentTerms: 'Condiciones de pago',
          woaInvoiceDate: 'WOA Factura Fecha',
          woaExpectedPay: 'Pago esperado de WOA',
          overpayment: 'Sobrepago',
          remainingPayment: 'Pago restante',
          payment: 'Pago',
          originalSOW: 'SOW original',
          invoice: 'Factura',

          // Contacts
          contacts: 'Contactos',
          projectCoordinator: 'Coordinador de proyectos',
          phone: 'Teléfono',
          ext: 'Extensión',
          fieldProjectManager: 'Gerente de Proyectos de Campo',
          superName: 'Súper Nombre',
          superPhone: 'Súper teléfono',
          superEmail: 'Súper correo electrónico',
          client: 'Cliente',

          // Location
          location: 'Ubicación',
          address: 'Dirección',
          city: 'Ciudad',
          state: 'Estado',
          zip: 'Código postal',
          market: 'Mercado',
          gateCode: 'Código de puerta',
          lockBoxCode: 'Código de caja de seguridad',
          hoaContactPhone: 'Teléfono de contacto de la HOA',
          hoaContactEmail: 'Correo electrónico de contacto de la HOA',

          // Misc
          misc: 'Misceláneos',
          created: 'Creado',
          new: 'Nuevo',
          active: 'Activo',
          punch: 'Puñetazo',
          closed: 'Cerrado',
          clientPaid: 'Cliente pagado',
          disputed: 'Cuestionado',
          collection: 'Recopilación',
          dueDateVariance: 'Variación de la fecha de vencimiento',
          payDateVariance: 'Variación de la fecha de pago',
          payVariance: 'Variación de pago',
          woaPaid: 'WOA pagado',
          reconcileDate: 'Reconciliada',
          verifiedDate: 'Verificada',

          save: 'Ahorrar',
          cancel: 'Cancelar',
          seeProjectDetails: 'Ver detalles del proyecto',
        },
      },
    },
  },
}
